import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';
import ProductTopSection from '../../../../components/Sangjo-Ujieon/ProductTopSection';
import ProductSubHeading from '../../../../components/Sangjo-Ujieon/ProductSubHeading';
import FuneralTabMobile from '../../../../components/Sangjo-Ujieon/FuneralTabMobile';

const FuneralInfoMobile = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState('buddhist'); // Default to Buddhist tab

  // Get the tab ID from URL search parameters
  useEffect(() => {
    const tabId = searchParams.get('tab');
    if (tabId && ['buddhist', 'christian', 'catholic'].includes(tabId)) {
      setActiveTab(tabId);
    }
  }, [searchParams]);

  // Handle tab click
  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    setSearchParams({ tab: tabId });
  };

  // Tab configuration
  const tabs = [
    { id: 'buddhist', label: '불교식', title: '불교식 장례절차' },
    { id: 'christian', label: '기독교식', title: '기독교식 장례절차' },
    { id: 'catholic', label: '천주교식', title: '천주교식 장례절차' }
  ];

  return (
    <div className="announcement-list-page product-info-page">
      <ProductTopSection />

      {/* Main Content */}
      <main className="main-content">
        <ProductSubHeading heading="장례정보" />

        {/* Main Content Section */}
        <div className="funeral-info-mobile-section">

          {/* Religious Funeral Procedures Section */}
          <div className="funeral-info-religious-section sky-hall-special-room-mobile-pricing-section">
            <FuneralTabMobile selectedHall="종교별 장례절차" />

            <div className="funeral-info-religious-section-content">

            {/* Religious Style Tabs */}
            <div className="funeral-info-religious-tabs">
              {tabs.map((tab) => (
                <div
                  key={tab.id}
                  className={`funeral-info-religious-tab ${activeTab === tab.id ? 'funeral-info-religious-tab-active' : ''}`}
                  onClick={() => handleTabClick(tab.id)}
                >
                  <span>{tab.label}</span>
                </div>
              ))}
            </div>

            {/* Religious Content Title */}
            <div className="funeral-info-religious-content-title">
              <h4>{tabs.find(tab => tab.id === activeTab)?.title}</h4>
            </div>

            {/* Buddhist Funeral Procedures Content */}
            {activeTab === 'buddhist' && (
              <div className="funeral-info-religious-content" id="funeral-info-religious-content-buddhist">
                <div className="funeral-info-religious-intro">
                  <p>불교 의례 규범인 석문의범(釋門儀範)에 따르면 장례를 다비(茶毗)라고 하여 화장으로 치른다. 영결식은 일정한 순서에 따라 행한다.</p>
                </div>

                <div className="funeral-info-religious-steps">
                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">1. 개식(開式)</div>
                      <div className="funeral-info-religious-step-description">호상(護喪)이 한다.</div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">2. 삼귀의례(三歸儀禮)</div>
                      <div className="funeral-info-religious-step-description">주례승이 하며 불(佛), 법(法), 승(僧)의 세가지 귀한 것(三寶)에 돌아가 의지한다는 불교의식이다.</div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">3. 약력보고</div>
                      <div className="funeral-info-religious-step-description">추모의 뜻으로 고인과 생존 시 가까웠던 친구가 한다.</div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">4. 착어(着語)</div>
                      <div className="funeral-info-religious-step-description">주례승이 부처의 교법(敎法)의 힘을 빌어 고인을 안정시키는 말이다.</div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">5. 창혼(唱魂)</div>
                      <div className="funeral-info-religious-step-description">주례승이 요령을 흔들며 하는데, 극락세계에 가서 고이 잠들라는 뜻이다.</div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">6. 헌화</div>
                      <div className="funeral-info-religious-step-description">친지 대표가 영전에 꽃을 바친다.</div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">7. 독경(讀經)</div>
                      <div className="funeral-info-religious-step-description">주례승과 참례자 모두가 염불(念佛)을 하는데, 고인의 혼을 안정시키고 이승에서의 모든 관계를 잊고 부처님 세계에 고이 잠들라는 뜻이다.</div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">8. 추도사</div>
                      <div className="funeral-info-religious-step-description">일반에서 하는 것과 같다.</div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">9. 소향(燒香)</div>
                      <div className="funeral-info-religious-step-description">일동이 함께 향을 태우며 추모하고 애도한다.</div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">10. 사홍서원(四弘誓願)</div>
                      <div className="funeral-info-religious-step-description">주례승이 하며 다음과 같다.</div>
                      <div className="funeral-info-religious-vows">
                        <div className="funeral-info-religious-vow">중생무변서원도(眾生無邊薯願度): 중생은 끝이 없으니 제도(濟度)하여 주기를 맹세함.</div>
                        <div className="funeral-info-religious-vow">번뇌무진서원단(煩惱無盡誓願斷): 인간의 번뇌는 끊기를 원하는 맹세.</div>
                        <div className="funeral-info-religious-vow">법문무량서원학(法門無量誓願學): 불교의 세계는 한량없으니 배우기를 원함.</div>
                        <div className="funeral-info-religious-vow">불도무상서원성(佛道無上誓원成): 불도보다 더 훌륭한 것이 없으니 불도를 이루기를 맹세코 원함.</div>
                      </div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">11. 폐식선언</div>
                      <div className="funeral-info-religious-step-description">
                        <p>결식 후 장지로 향한다.</p>
                        <p>화장이 끝날 때까지 염불을 하며, 화장이 끝나면 주례승이 흰 창호지에 유골을 받아 상제에게 주면, 쇄골 후 절에 봉안하고 제사를 지낸다. 제의(祭儀)로는 49재, 백일제, 3년상을 지낸다.</p>
                        <p>또 고인의 생일을 맞으면 추도식을 갖기도 한다. 준비하고 진행한다.</p>
                        <p>상기가 끝난 뒤 복(服)을 벗는 절차이다. 탈상은 부모 조부모 배우자의 경우, 별세한 날로부터 100일까지이고 그 밖의 경우는 장례일까지이다. (가정의례준칙) 이때 지내는</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Christian Funeral Procedures Content */}
            {activeTab === 'christian' && (
              <div className="funeral-info-religious-content" id="funeral-info-religious-content-christian">
                <div className="funeral-info-religious-intro">
                  <p>전체 과정은 목사의 주례로 진행됩니다. 임종예배에서는 찬송과 기도로 고인의 영혼을 하나님께 맡기며, 유족들은 기도회를 갖습니다.</p>
                  <p>전통 장례와의 차이점은 곡을 하지 않고, 음식을 차리지 않으며, 절도 하지 않는다. 분향을 하지 않고 헌화를 한다.</p>
                  <p>장례 기간은 전통적으로 홀수일(3, 5, 7일)이지만 최근에는 3일장이 일반적입니다. 교회는 이 숫자에 얽매이지 않고 주일이 겹치면 2일장이나 4일장을 치르기도 합니다.</p>
                </div>

                <div className="funeral-info-religious-steps">
                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">1. 임종예배</div>
                      <div className="funeral-info-religious-step-description">
                        <p>신자가 임종에 가까워지면 먼저 담임목사에게 연락합니다. 사망 시 임종예배를 드리고 장례 일정과 기타 사항을 상의합니다.</p>
                        <p>곡을 하지 않고, 제사를 차리지 않으며, 경건하게 장례를 준비하고 진행합니다.</p>
                      </div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">2. 입관예배</div>
                      <div className="funeral-info-religious-step-description">
                        <p>목사의 지도하에 유족들이 고인의 염습과 수의를 지켜보고, 입관 후 입관예배를 드립니다.</p>
                        <p>상복은 남자는 검은 양복에 상장을, 여자는 흰색 또는 검은 치마저고리를 착용하여 통일된 복장을 유지합니다.</p>
                      </div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">3. 조문맞이</div>
                      <div className="funeral-info-religious-step-description">
                        <p>기독교식 장례에서는 분향을 하지 않고 헌화를 합니다.</p>
                        <p>일반 조문객을 위해 장례식장 입구에 헌화용 꽃을 준비합니다.</p>
                        <p>간혹 일반 조문객을 고려하여 분향도 할 수 있도록 준비하기도 합니다.</p>
                      </div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">4. 발인(출관)예배</div>
                      <div className="funeral-info-religious-step-description">
                        <p>하나님께 영광을 돌리고, 유족들에게 위로와 소망을 주며, 조문객들에게 하나님의 사랑과 의를 알리는 예배입니다.</p>
                      </div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">5. 영결식순</div>
                      <div className="funeral-info-religious-step-description">
                        <p>주례승이 하며 다음과 같다.</p>
                        <div className="funeral-info-religious-vows">
                          <div className="funeral-info-religious-vow"><span>개식사</span> - 주례목사</div>
                          <div className="funeral-info-religious-vow"><span>신앙고백 및 찬송</span> - 사도신경, 찬송(534장)을 다같이 한다.</div>
                          <div className="funeral-info-religious-vow"><span>기도</span> - 고인의 명복과 유족에게 위로를 내리시길 기원한다.</div>
                          <div className="funeral-info-religious-vow"><span>성경봉독</span> - 고린도후서 5장 1절, 디모데전서 6장 7절 등을 낭독.</div>
                          <div className="funeral-info-religious-vow"><span>기도 및 위로의 말씀</span></div>
                          <div className="funeral-info-religious-vow"><span>약력보고</span> - 유가족 대표나 교회 대표.</div>
                          <div className="funeral-info-religious-vow"><span>찬송 및 주기도문</span></div>
                          <div className="funeral-info-religious-vow"><span>출관</span></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">6. 하관</div>
                      <div className="funeral-info-religious-step-description">
                        <p>목사의 주례 하에 신앙고백과 성경낭독, 그리고 하나님으로부터 왔다가 다시돌아감을 선언하고, 고인의 명복을 비는 기도와 찬송을 하며 축도 순으로 식을 진행한다. 찬송 속에 헌화와 취토를 하고 성분을 한다. 기독교식이라 하여꼭 매장하여야 하는 것은 아니며 화장도 교리에 어긋나지 않는다. 실제로 교회나 기독교인들의 화장도 점차 증가하고 있는 추세이다.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Catholic Funeral Procedures Content */}
            {activeTab === 'catholic' && (
              <div className="funeral-info-religious-content" id="funeral-info-religious-content-catholic">
                <div className="funeral-info-religious-intro">
                  <p>생전에 세례를 받은 신자는 천주교식 장례를 치른다. 천주교식 장례는 '성교례규(聖教禮規)'에 따라 진행된다.</p>
                  <p>천주교 신자나 기독교 신자라도 전통적인 풍속이나 의례를 병행할 수 있으나, 신앙에 어긋나지 않는 범위 내에서만 허용된다.</p>
                </div>

                <div className="funeral-info-religious-steps">
                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">1. 임종 전</div>
                      <div className="funeral-info-religious-step-description">
                        <p>가능하면 정신이 맑을 때 미리 세례를 받는 것이 좋고, 세례받을 의사를 표현하고 실천하는 것이 바람직하다.</p>
                        <p>임종이 임박하여 급하게 세례를 받고 싶지만 사제를 부를 시간이 없을 때는 본당장이나 수녀가 세례를 줄 수 있다.</p>
                        <p>사망이 예견될 때는 흰 종이 또는 흰 천을 깐 상, 십자가, 촛대 2개, 성수 그릇, 성수 뿌리개를 준비하고 사제를 미리 연락한다.</p>
                      </div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">2. 종부성사(終傅聖사)</div>
                      <div className="funeral-info-religious-step-description">
                        <p>운명할 때 행하는 성사로 가족들은 미리 환자의 눈, 코, 입, 손과 발을 씻기고 신부에게 고해성사를 할 수 있도록 모두 물러난다. 고해성사가 끝나면 신부는 종부성사를 행한다.</p>
                        <p>임종시 신부가 없을 경우에는 주위 가족들이 위로와 격려의 말을 들려주고 성서 가운데 거룩한 구절을 읽어 준다.</p>
                      </div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">3. 운명</div>
                      <div className="funeral-info-religious-step-description">
                        <p>운명 시에는 성초에 불을 켜고 임종경(臨終經)이나 성모덕서도문, 매괴경 등을 읽는다. 운명한 뒤에도 얼마 동안 계속해 주며 편안함 임종을 위해 거룩한 기도문이나 성가를 들려준다.</p>
                        <p>환자가 운명하면 눈과 입을 다물게 하고 두 손을 합장시켜 십자고상을 쥐어 준다. 상위에 고상을 모시고 좌우에 촛불을 켜며 성수와 성수채를 입관 때까지 놓아둔다.</p>
                        <p>가족들은 그 옆에 꿇어 앉아 연도(煉禱)한다. 염경이 끝날 때마다 성수를 뿌리며 만 하루가 지나면 정해진 경을 외고 시신을 닦고 수의를 입혀 입관한다.</p>
                      </div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">4. 위령미사(연미사)</div>
                      <div className="funeral-info-religious-step-description">
                        <p>연옥에 있는 영혼들을 위해 하느님께 바치는 미사이다. 운명하면 즉시 본당신부에게 알리고 미사헌금을 전달하여 미사를 청한다. 장례일정과 미사일정을 상의하여 결정한다.</p>
                      </div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">5. 장례미사</div>
                      <div className="funeral-info-religious-step-description">
                        <p>사제의 주례 하에 신앙고백과 성경낭독, 그리고 하느님으로부터 왔다가 다시 돌아감을 선언하고, 고인의 명복을 비는 기도와 찬미를 하며 축도 순으로 미사를 진행한다.</p>
                        <p>찬미 속에 헌화와 취토를 하고 성분을 한다. 천주교식이라 하여 꼭 매장하여야 하는 것은 아니며 화장도 교리에 어긋나지 않는다. 실제로 교회나 천주교인들의 화장도 점차 증가하고 있는 추세이다.</p>
                      </div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">6. 하관</div>
                      <div className="funeral-info-religious-step-description">
                        <p>하관지에 도착하면 묘지 축성 기도를 드린다. 관과 묘지에 성수를 뿌린 후 하관기도를 드리고 매장한다.</p>
                      </div>
                    </div>
                  </div>

                  <div className="funeral-info-religious-step">
                    <div className="funeral-info-religious-step-content">
                      <div className="funeral-info-religious-step-title">7. 장례 후</div>
                      <div className="funeral-info-religious-step-description">
                        <p>3일, 7일, 30일, 소상과 대상 때에 연미사를 올리고 가족의 고해, 영성체를 행한다. 천주교 상례에서도 신앙에 어긋나지 않는 범위에서 간소한 음식을 접대하거나 묘소를 찾고 성묘하는 것 등은 예전부터 행하여 왔다.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            </div>
          </div>

        </div>
      </main>
    </div>
  );
};

export default FuneralInfoMobile;


